import { useTranslation } from 'react-i18next';
import OrderLayout, {
  OrderLayoutProps,
} from '@src/pages/orders/components/OrderLayout';

type Props = Omit<OrderLayoutProps, 'title'>;

function NifOrderLayout(props: Props): JSX.Element {
  const { t } = useTranslation('nif');
  return <OrderLayout {...props} title={t('order.title', 'Order a NIF')} />;
}

export default NifOrderLayout;
